import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchCitiesByState } from '../services/api';

interface ClaimState {
  claimId: number | null;
  claimStatus: string | null;
  facility_state: string;
  facility_city: string;
  facility_id: string;
  facility_unit: string;
  reporter_first_name: string;
  reporter_last_name: string;
  reporter_phone: string;
  owner_address_1: string;
  owner_address_2: string;
  owner_city: string;
  owner_state: string;
  owner_email: string;
  owner_zip_code: string;
  incident_date: string;
  tpp_loss_type_id: string;
  other_loss_type_description: string;
  damaged_items: string;
  damage_description: string;
  damage_estimate: string;
  authority_name: string;
  authority_filed_report: string;
  info_manager_notified: string;
  damage_discovered_by: string;
  items_current_location: string;
  another_claim_filed: string;
  another_claim_loss_type_id: string;
  another_claim_date: string;
  cities: string[];
}

const initialState: ClaimState = {
  claimId: null,
  claimStatus: null,
  facility_state: '',
  facility_city: '',
  facility_id: '',
  facility_unit: '',
  reporter_first_name: '',
  reporter_last_name: '',
  reporter_phone: '',
  owner_address_1: '',
  owner_address_2: '',
  owner_city: '',
  owner_state: '',
  owner_email: '',
  owner_zip_code: '',
  incident_date: '',
  tpp_loss_type_id: '',
  other_loss_type_description: '',
  damaged_items: '',
  damage_description: '',
  damage_estimate: '',
  authority_name: '',
  authority_filed_report: '',
  info_manager_notified: '',
  damage_discovered_by: '',
  items_current_location: '',
  another_claim_filed: '',
  another_claim_loss_type_id: '',
  another_claim_date: '',
  cities: [],
};

type StringFields = Exclude<keyof ClaimState, 'cities' | 'claimId' | 'claimStatus'>;

const claimSlice = createSlice({
  name: 'claim',
  initialState,
  reducers: {
    setClaimId: (state, action: PayloadAction<number | null>) => {
      state.claimId = action.payload;
    },
    setClaimStatus: (state, action: PayloadAction<string | null>) => {
      state.claimStatus = action.payload;
    },
    updateClaimField: (
      state,
      action: PayloadAction<{ field: StringFields; value: string }>
    ) => {
      const { field, value } = action.payload;
      state[field] = value;
    },
    resetForm: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCitiesByState.fulfilled, (state, action) => {
        state.cities = action.payload;
      })
      .addCase(fetchCitiesByState.rejected, (state) => {
        state.cities = [];
      });
  },
});

export const { setClaimId, setClaimStatus, updateClaimField, resetForm } = claimSlice.actions;
export default claimSlice.reducer; 